export enum RoleCodes {
 ROOT_ADMIN = 'ROOT_ADMIN',
 COMPANY_ADMIN = 'COMPANY_ADMIN',
 COMPANY_MANAGER = 'COMPANY_MANAGER',
 COMPANY_USER = 'COMPANY_USER',
 BATCH_ADMIN = 'BATCH_ADMIN',
}